import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  computed,
  forwardRef,
  Injector,
  Input,
  signal,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputTextModule } from 'primeng/inputtext';
import { EcoHelperTextComponent } from '../eco-helper-text/eco-helper-text.component';

@Component({
  selector: 'eco-input-text',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    TranslateModule,
    EcoHelperTextComponent,
  ],
  templateUrl: './eco-input-text.component.html',
  styleUrl: './eco-input-text.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EcoInputTextComponent),
      multi: true,
    },
  ],
})
export class EcoInputTextComponent
  implements ControlValueAccessor, AfterViewInit
{
  value?: string;
  ngControl = signal<NgControl | null>(null);
  isRequired = computed(() => {
    const control = this.ngControl();
    if (control) {
      const validator = control.control?.validator
        ? control.control.validator({} as any)
        : null;
      return validator && validator['required'];
    }
    return false;
  });

  @Input() label?: string;
  @Input() disabled = false;
  @Input() placeholder?: string;

  constructor(private injector: Injector) {}

  onChange = (value: string) => {};
  onTouched = () => {};

  ngAfterViewInit() {
    this.ngControl.set(this.injector.get(NgControl, null));
  }

  writeValue(value: string): void {
    this.value = value;
    this.onChange(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onValueChange(value: string) {
    this.writeValue(value);
    this.onTouched();
  }
}
